import { Component } from '@angular/core';

@Component({
  selector: 'app-autenticacao-realizada',
  templateUrl: './autenticacao-realizada.component.html',
  styleUrls: ['./autenticacao-realizada.component.scss']
})
export class AutenticacaoRealizadaComponent { }
